import axios from 'axios'

class ConfiguracaoApiClient {

    async inserirConfiguracao(dados) {
        const formData = new FormData()
        formData.append('input', new Blob([JSON.stringify(dados.input)], {type: 'application/json'}))
        if (dados.fotoEmpresa) {
            formData.append('fotoEmpresa', dados.fotoEmpresa)
        }

        return axios.post('/configuracao/inserir', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    }

    async atualizarConfiguracao(dados) {
        const formData = new FormData()
        formData.append('input', new Blob([JSON.stringify(dados.input)], {type: 'application/json'}))
        if (dados.fotoEmpresa) {
            formData.append('fotoEmpresa', dados.fotoEmpresa)
        }

        return axios.put('/configuracao/atualizar', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    }

    async buscarParametrosConfiguracao() {
        return await axios.get('/configuracao/buscarParametros')
    }

    async buscarListaDeConfiguracoes() {
        return await axios.get('/configuracao/buscarConfiguracoesEmpresa')
    }

    async deletarConfiguracao(configuracaoId) {
        await axios.delete(`/configuracao/deletar/${configuracaoId}`)
    }

}

export default new ConfiguracaoApiClient()
